import React,{useState,useEffect} from 'react'
import SidebarOfAdash from '../../subComponent/SidebarOfAdash'
import HeaderofAdash from '../../subComponent/HeaderofAdash'
import {Row,Col,Modal} from 'react-bootstrap'
import Dropdown2 from '../../../subComponents/CustomSubComponents/Dropdown2'
import { optionsShowtt, optionsStatus, optionsdept } from '../../../Helper'

import ReactPaginate from 'react-paginate'
import PillSmall from '../../../subComponents/CustomSubComponents/PillSmall'

import Purplebutton from '../subComponent/Purplebutton'
import { validationComp, validationDrp } from '../../../subComponents/CustomSubComponents/ValidationComp'
import { hrJobManagementApi } from '../../../../utils/AdminDashApi/HRJobManagementApi'
const HRJobManagementComp = () => {
    const [show,setShow] = useState(10)
   
    const [departmentMod1,setdepartmentMod1]= useState("")
    const [labeldepartmentMod1,setlabeldepartmentMod1]= useState("")
    const [borderdepartmentMod1,setborderdepartmentMod1]= useState("")
    const [roleMod1,setroleMod1]= useState("")
    const [labelroleMod1,setlabelroleMod1]= useState("")
    const [borderroleMod1,setborderroleMod1]= useState("")

    const [borderempnameMod2,setborderempnameMod2] = useState("")
    const [labelempnameMod2,setlabelempnameMod2] = useState("")
    const [idMod2,setidMod2] = useState("")
    const [borderidMod2,setborderidMod2] = useState("")
    const [labelidMod2,setlabelidMod2] = useState("")
    const [emailMod2,setemailMod2]= useState("")
    const [labelemailMod2,setlabelemailMod2]= useState("")
    const [borderemailMod2,setborderemailMod2]= useState("")
    const [departmentMod2,setdepartmentMod2]= useState("")
    const [labeldepartmentMod2,setlabeldepartmentMod2]= useState("")
    const [borderdepartmentMod2,setborderdepartmentMod2]= useState("")
    const [roleMod2,setroleMod2]= useState("")
    const [labelroleMod2,setlabelroleMod2]= useState("")
    const [borderroleMod2,setborderroleMod2]= useState("")
    const [statusMod2,setstatusMod2]= useState("")
    const [labelstatusMod2,setlabelstatusMod2]= useState("")
    const [borderstatusMod2,setborderstatusMod2]= useState("")
    const [levelMod1,setlevelMod1]= useState("")
    const [labellevelMod1,setlabellevelMod1]= useState("")
    const [borderlevelMod1,setborderlevelMod1]= useState("")
    const [salaryRangeMod1,setsalaryRangeMod1]= useState("")
    const [labelsalaryRangeMod1,setlabelsalaryRangeMod1]= useState("")
    const [bordersalaryRangeMod1,setbordersalaryRangeMod1]= useState("")
    const [employeeTypeMod1,setemployeeTypeMod1]= useState("")
    const [labelemployeeTypeMod1,setlabelemployeeTypeMod1]= useState("")
    const [borderemployeeTypeMod1,setborderemployeeTypeMod1]= useState("")
    const [workPlaceMod1,setworkPlaceMod1]= useState("")
    const [labelworkPlaceMod1,setlabelworkPlaceMod1]= useState("")
    const [borderworkPlaceMod1,setborderworkPlaceMod1]= useState("")      
    const [expRequiredMod1,setexpRequiredMod1]= useState("")
    const [labelexpRequiredMod1,setlabelexpRequiredMod1]= useState("")
    const [borderexpRequiredMod1,setborderexpRequiredMod1]= useState("")
    const [descriptionMod1,setdescriptionMod1]= useState("")
    const [labeldescriptionMod1,setlabeldescriptionMod1]= useState("")
    const [borderdescriptionMod1,setborderdescriptionMod1]= useState("")

    const [levelMod2,setlevelMod2]= useState("")
    const [labellevelMod2,setlabellevelMod2]= useState("")
    const [borderlevelMod2,setborderlevelMod2]= useState("")
    const [salaryRangeMod2,setsalaryRangeMod2]= useState("")
    const [labelsalaryRangeMod2,setlabelsalaryRangeMod2]= useState("")
    const [bordersalaryRangeMod2,setbordersalaryRangeMod2]= useState("")
    const [employeeTypeMod2,setemployeeTypeMod2]= useState("")
    const [labelemployeeTypeMod2,setlabelemployeeTypeMod2]= useState("")
    const [borderemployeeTypeMod2,setborderemployeeTypeMod2]= useState("")
    const [workPlaceMod2,setworkPlaceMod2]= useState("")
    const [labelworkPlaceMod2,setlabelworkPlaceMod2]= useState("")
    const [borderworkPlaceMod2,setborderworkPlaceMod2]= useState("")      
    const [expRequiredMod2,setexpRequiredMod2]= useState("")
    const [labelexpRequiredMod2,setlabelexpRequiredMod2]= useState("")
    const [borderexpRequiredMod2,setborderexpRequiredMod2]= useState("")
    const [descriptionMod2,setdescriptionMod2]= useState("")
    const [labeldescriptionMod2,setlabeldescriptionMod2]= useState("")
    const [borderdescriptionMod2,setborderdescriptionMod2]= useState("")

    const [show2,setShow2] = useState(false)
    const [show3,setShow3] = useState(false)

    const handleClose=()=>{
        setShow2(false)
    }

    const drpfuncLevelMod1=(myval,myid)=>{
        setlevelMod1(myval)
    }
    const drpfuncWorkPlaceMod1=(myval,myid)=>{
        setworkPlaceMod1(myval)
    }
    const drpfuncEmpTypeMod1=(myval,myid)=>{
        setemployeeTypeMod1(myval)
    }
    const drpfuncLevelMod2=(myval,myid)=>{
        setlevelMod2(myval)
    }
    const drpfuncWorkPlaceMod2=(myval,myid)=>{
        setworkPlaceMod2(myval)
    }
    const drpfuncEmpTypeMod2=(myval,myid)=>{
        setemployeeTypeMod2(myval)
    }

    const handlesaveModal1=()=>{
      //Mod1validation
      validationDrp(roleMod1,setlabelroleMod1,setborderroleMod1,"Role Required")
  
      validationDrp(departmentMod1,setlabeldepartmentMod1,setborderdepartmentMod1,"Department Required")
      validationDrp(levelMod1,setlabellevelMod1,setborderlevelMod1,"Level Required")
      validationDrp(employeeTypeMod1,setlabelemployeeTypeMod1,setborderemployeeTypeMod1,"Employee Type Required")
      validationDrp(workPlaceMod1,setlabelworkPlaceMod1,setborderworkPlaceMod1,"Work Plave Required")
      validationComp(salaryRangeMod1,setlabelsalaryRangeMod1,setbordersalaryRangeMod1,"Salary Range Required")
      validationComp(expRequiredMod1,setlabelexpRequiredMod1,setborderexpRequiredMod1,"Experience Required")
      validationComp(descriptionMod1,setlabeldescriptionMod1,setborderdescriptionMod1,"Description Required")
    }
    const handlesaveModal2=()=>{
      //Mod2validation
      validationDrp(roleMod2,setlabelroleMod2,setborderroleMod2,"Role Required") 
      validationDrp(departmentMod2,setlabeldepartmentMod2,setborderdepartmentMod2,"Department Required")
      validationDrp(levelMod2,setlabellevelMod2,setborderlevelMod2,"Level Required")
      validationDrp(employeeTypeMod2,setlabelemployeeTypeMod2,setborderemployeeTypeMod2,"Employee Type Required")
      validationDrp(workPlaceMod2,setlabelworkPlaceMod2,setborderworkPlaceMod2,"Work Plave Required")
      validationComp(salaryRangeMod2,setlabelsalaryRangeMod2,setbordersalaryRangeMod2,"Salary Range Required")
      validationComp(expRequiredMod2,setlabelexpRequiredMod2,setborderexpRequiredMod2,"Experience Required")
      validationComp(descriptionMod2,setlabeldescriptionMod2,setborderdescriptionMod2,"Description Required")
    }

    const handlecross=(fullItem)=>{

    }

    const drpfuncshow=(myval,id)=>{
        setShow(myval)        
      }
    const drpfuncdeptMod1 = (myval,myid) =>{
      setdepartmentMod1(myval)
    }
    const drpfuncroleMod1 = (myval,myid)=>{
      setroleMod1(myval)

    }
     
    const drpfuncdeptMod2 = (myval,myid) =>{
      setdepartmentMod2(myval)
    }
    const drpfuncroleMod2 = (myval,myid)=>{
      setroleMod2(myval)

    }
     
      const handleClose2=()=>{
        setShow3(false)
      }
      const [mainpagesearch,setmainpagesearch] = useState("")
  const handlemainpagesearch=(e)=>{
    setmainpagesearch(e.target.value)
  }
  const [pageCount, setPageCount] = useState(0);
  const [pageCountfiltered, setPageCountfiltered] = useState(0);
  // Here we use item offsets; we could also use page offsets
  // following the API or data you're working with.
  const [itemOffset, setItemOffset] = useState(0);
  const [itemOffsetfiltered, setItemOffsetfiltered] = useState(0);
  const [itemsPerPage,setitemsPerPage] = useState(10);
  const [paginatenumselected,setpaginatenumselected] = useState(0)
  const [paginatenumselectedfiltered,setpaginatenumselectedfiltered] = useState(0)
  const [pageCount2, setPageCount2] = useState(0);
  // Here we use item offsets; we could also use page offsets
  // following the API or data you're working with.
  const [itemOffset2, setItemOffset2] = useState(0);
  const [itemsPerPage2,setitemsPerPage2] = useState(10);
  
  const [itemsPerPagefiltered,setitemsPerPagefiltered] = useState(10);
  const [paginatenumselected2,setpaginatenumselected2] = useState(0)
  const [filteredArr,setfilteredArr] = useState(hrJobManagementApi.data)
  const [tempfilteredarr,settempfilteredarr] = useState([])
  let [pagecountoffilter,setpagecountoffilter] = useState(filteredArr.length)
  

  useEffect(() => {
    const endOffsetfiltered = itemOffsetfiltered + itemsPerPagefiltered;
    const tempArr = filteredArr.slice(itemOffsetfiltered, endOffsetfiltered);
    settempfilteredarr(tempArr);
    setPageCountfiltered(Math.ceil(filteredArr.length / itemsPerPagefiltered));
    setitemsPerPagefiltered(show?show:10)
    //flag2
  }, [itemOffsetfiltered, itemsPerPagefiltered, filteredArr,show]);

      const handlePageClick = (event) => {
        const newOffset = event.selected * itemsPerPage % hrJobManagementApi.data.length;        
        setpaginatenumselected(event.selected);
        setItemOffset(newOffset);
      };
      const handlePageClickfiltered = (event) => {
        const newOffsetf = event.selected * itemsPerPagefiltered % pagecountoffilter;        
        setpaginatenumselectedfiltered(event.selected);
        setItemOffsetfiltered(newOffsetf);
      };
      const handleAddNewSalary=()=>{
        setShow2(true)
      }
      //start
  return (
    <>
    <div className="d-flex flexvaluecomp">
        <SidebarOfAdash />
        <div className="contentpartwidthwrapper">
            <HeaderofAdash head="Job Management" />
            <div className="contentofadmindash contentflexvalue routineentry ">
            <Row style={{marginTop:"20px"}}>
                <Col lg={12} className="text-center" style={{marginBottom:"25px"}}>
                    <Purplebutton clickfunc={handleAddNewSalary} w="202px" h="40px" btnname="+ Post New Job" />
                </Col>
                <Col className="m-auto" lg={4}>
                  <Row>
                    <Col lg={3}>
                    <div className="basicinput">
                      <p>Show</p>
                      <div className="dropdownwrapper">
                        
                          <Dropdown2 func={drpfuncshow} myplaceholder="Select" fontsize="16" fontfamily="'Poppins', sans-serif"  options={optionsShowtt}/>
                      </div>
                      </div>
                    </Col>
                    <Col lg={9}>
                            <div className="basicinput">
                              <p>Search</p>
                              <div className="wrap">
                              <input type="text" placeholder="Search" value={mainpagesearch} onChange={handlemainpagesearch}/>
                              <img src="./assets/images/dashboards/adminDashboard/flexvalue/search.png" alt="" />

                              </div>
                            </div>
                    </Col>
                  </Row>
                 

                </Col>
              </Row>
              <Row style={{marginTop:"40px"}}>
                <Col lg={10} className="m-auto" >
                  <div className="flexvaluetable bigtable3000 ">
                    <table>
                      <thead>
                        <tr>
                            {
                              hrJobManagementApi.heading.map((item,key)=>{
                                return(
                                  <th key={key}> <div>{item.head}</div> </th>
                                )
                              })
                            }
                        </tr>
                      </thead>
                      {
                        // mainpagesearch==""?
                          <tbody>
                          {
                            tempfilteredarr.length!==0?
                          

                            tempfilteredarr.map((item,key)=>{
                              return(
                                <tr key={key}>
                                  <td>{item.role}</td>
                                  <td>{item.department}</td>
                                  <td>{item.level}</td>
                                  <td>{item.salaryrange}</td>
                                  <td>{item.employementtype}</td>
                                  <td>{item.workplace}</td>
                                  <td>{item.experienceRequired}</td>
                                  <td>{item.description}</td>
                                  
                                  
                                  <td>
                                      <div className="div w-100 d-flex justify-content-center">
                                        <div className="div d-flex align-items-center">
                                      <img onClick={()=>setShow3(true)} src={item.action.edit} alt="" style={{margin:"0 6px"}}/>
                                      <img onClick={()=>handlecross(item)} src={item.action.cross} alt="" style={{margin:"0 6px"}}/>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              )
                            })
                            :
                            ""
                         
                          }
                        </tbody>                        
                      }
                       
                    </table>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col lg={10} className="m-auto">
                    {
                      filteredArr.length!==0?
                  <Row>
                  <Col lg={6}>
                        <p className='pagileft'>Showing {itemOffsetfiltered+1} to {itemOffsetfiltered+10} of {filteredArr.length} entries (filtered from 10 total entries)</p>
                  </Col>
                  <Col lg={6} className="ms-auto">
                  <ReactPaginate
                      breakLabel="..."
                      nextLabel="next"
                      onPageChange={handlePageClickfiltered}
                      pageRangeDisplayed={5}
                      pageCount={pageCountfiltered}
                      previousLabel="previous"
                      renderOnZeroPageCount={null}
                      containerClassName='pagination'
                      pageLinkClassName='page-num'
                      previousLinkClassName='page-numl'
                      nextLinkClassName='page-numr'
                      activeLinkClassName='activelink'
                      disabledClassName="disabledClass"
                      
                    />
                  </Col>
                  </Row>
                      
                      :
                      
                  <Row>
                  <Col lg={6}>
                        <p className='pagileft'>Showing {itemOffset+1} to {itemOffset+10} of {hrJobManagementApi.data.length} entries (filtered from 10 total entries)</p>
                  </Col>
                  <Col lg={6} className="ms-auto">
                  <ReactPaginate
                      breakLabel="..."
                      nextLabel="next"
                      onPageChange={handlePageClick}
                      pageRangeDisplayed={5}
                      pageCount={pageCount}
                      previousLabel="previous"
                      renderOnZeroPageCount={null}
                      containerClassName='pagination'
                      pageLinkClassName='page-num'
                      previousLinkClassName='page-numl'
                      nextLinkClassName='page-numr'
                      activeLinkClassName='activelink'
                      disabledClassName="disabledClass"
                      
                    />
                  </Col>
                  </Row>
                    }
                </Col>
               
              </Row>
               {/* modal1ori */}

               <Modal dialogClassName="mymodalclsSubjectAdmin" show={show2} onHide={handleClose} backdrop="static"
              keyboard={false}>
               
                <Modal.Header closeButton>
                  <Modal.Title className="ms-auto">Employee Salary Entry</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <Row>
                    <Col lg={10} className="m-auto">
                      <Row>
                      <Col lg={6} className="pr7">
                          <div className="basicinput modalinputgap">
                          
                                <p>Role</p>
                                <div className="inputgap h40">

                                <div className="dropdownwrapper" >
                                    
                                    <Dropdown2 err={borderroleMod1} func={drpfuncroleMod1} myplaceholder="Select" fontsize="16" fontfamily="'Poppins', sans-serif"  options={optionsStatus}/>
                                </div>
                                <label>{labelroleMod1}</label>
                                </div>
                                
                                </div>
                          </Col>
                        <Col lg={6} className="pl7">
                        <div className="basicinput modalinputgap">
                          
                          <p>Department</p>
                          <div className="inputgap h40">

                          <div className="dropdownwrapper" >
                              
                              <Dropdown2 err={borderdepartmentMod1} func={drpfuncdeptMod1} myplaceholder="Select" fontsize="16" fontfamily="'Poppins', sans-serif"  options={optionsdept}/>
                          </div>
                          <label>{labeldepartmentMod1}</label>
                          </div>
                          
                          </div>
                          </Col>
                        
                        
                          <Col lg={6} className="pr7">
                          <div className="basicinput modalinputgap">                          
                                <p>Level</p>
                                <div className="inputgap h40">
                                <div className="dropdownwrapper">
                                    
                                    <Dropdown2 err={borderlevelMod1} func={drpfuncLevelMod1} myplaceholder="Select" fontsize="16" fontfamily="'Poppins', sans-serif"  options={optionsStatus}/>
                                </div>                                
                                <label>{labellevelMod1}</label>
                                </div>
                                </div>
                          </Col>
                          <Col lg={6} className="pl7">
                          
                          <div className="basicinput modalinputgap">
                            <p>Salary Range</p>
                            <div className="inputgap">
  
                            <div className="dropdownwrapper">
                              
                                <input type="text" style={bordersalaryRangeMod1 ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }} value={salaryRangeMod1} onChange={(e)=>setsalaryRangeMod1(e.target.value)}/>
                            </div>
                            <label>{labelsalaryRangeMod1}</label>
                            </div>
                            </div>
                          </Col>
                          <Col lg={6} className="pr7">
                          <div className="basicinput modalinputgap">                          
                                <p>Employee Type</p>
                                <div className="inputgap h40">
                                <div className="dropdownwrapper">
                                    
                                    <Dropdown2 err={borderemployeeTypeMod1} func={drpfuncEmpTypeMod1} myplaceholder="Select" fontsize="16" fontfamily="'Poppins', sans-serif"  options={optionsStatus}/>
                                </div>                                
                                <label>{labellevelMod1}</label>
                                </div>
                                </div>
                          </Col>
                          <Col lg={6} className="pl7">
                          <div className="basicinput modalinputgap">                          
                                <p>Work Place</p>
                                <div className="inputgap h40">
                                <div className="dropdownwrapper">
                                    
                                    <Dropdown2 err={borderworkPlaceMod1} func={drpfuncWorkPlaceMod1} myplaceholder="Select" fontsize="16" fontfamily="'Poppins', sans-serif"  options={optionsStatus}/>
                                </div>                                
                                <label>{labelworkPlaceMod1}</label>
                                </div>
                                </div>
                          </Col>
                          <Col lg={6} className="pr7">
                          
                          <div className="basicinput modalinputgap">
                            <p>Experience Required</p>
                            <div className="inputgap">
  
                            <div className="dropdownwrapper">
                              
                                <input type="text" style={borderexpRequiredMod1 ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }} value={expRequiredMod1} onChange={(e)=>setexpRequiredMod1(e.target.value)}/>
                            </div>
                            <label>{labelexpRequiredMod1}</label>
                            </div>
                            </div>
                          </Col>
                          <Col lg={12}>
                               
                          <div className="basicinput modalinputgap w-100">

                           <p>Description</p>
                               <div className="inputgap" style={{height:"100px",width:"100%"}}>
                               <textarea  style={borderdescriptionMod1 ? { borderColor: "rgb(237, 28, 36)",width:"100%",height:"100px" } : { borderColor: "rgba(0,0,0,0.2)",width:"100%",height:"100px" }} className="textbox" type="text" name="description" value={descriptionMod1} onChange={(e)=>setdescriptionMod1(e.target.value)} placeholder=''/>
                               <label>{labeldescriptionMod1}</label>
                               </div> 
                          </div>

                             

                           
                              
                   </Col>
                      
                        
                    
                       
                       
                      </Row>
                   
                    </Col>
                    
                  </Row>

                </Modal.Body>
                <Modal.Footer className="m-auto" style={{borderTop:"0"}}>
                  <button variant="secondary" type="button" onClick={handleClose}>
                    Close
                  </button>
                  <button variant="primary" onClick={handlesaveModal1}>
                    Save
                  </button>
                </Modal.Footer>

                
              </Modal>
               {/* modal2ori */}

               <Modal dialogClassName="mymodalclsSubjectAdmin" show={show3} onHide={handleClose2} backdrop="static"
              keyboard={false}>
               
                <Modal.Header closeButton>
                  <Modal.Title className="ms-auto">Job Management</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                <Row>
                    <Col lg={10} className="m-auto">
                      <Row>
                      <Col lg={6} className="pr7">
                          <div className="basicinput modalinputgap">
                          
                                <p>Role</p>
                                <div className="inputgap h40">

                                <div className="dropdownwrapper" >
                                    
                                    <Dropdown2 err={borderroleMod2} func={drpfuncroleMod2} myplaceholder="Select" fontsize="16" fontfamily="'Poppins', sans-serif"  options={optionsStatus}/>
                                </div>
                                <label>{labelroleMod2}</label>
                                </div>
                                
                                </div>
                          </Col>
                        <Col lg={6} className="pl7">
                        <div className="basicinput modalinputgap">
                          
                          <p>Department</p>
                          <div className="inputgap h40">

                          <div className="dropdownwrapper" >
                              
                              <Dropdown2 err={borderdepartmentMod2} func={drpfuncdeptMod2} myplaceholder="Select" fontsize="16" fontfamily="'Poppins', sans-serif"  options={optionsdept}/>
                          </div>
                          <label>{labeldepartmentMod2}</label>
                          </div>
                          
                          </div>
                          </Col>
                        
                        
                          <Col lg={6} className="pr7">
                          <div className="basicinput modalinputgap">                          
                                <p>Level</p>
                                <div className="inputgap h40">
                                <div className="dropdownwrapper">
                                    
                                    <Dropdown2 err={borderlevelMod2} func={drpfuncLevelMod2} myplaceholder="Select" fontsize="16" fontfamily="'Poppins', sans-serif"  options={optionsStatus}/>
                                </div>                                
                                <label>{labellevelMod2}</label>
                                </div>
                                </div>
                          </Col>
                          <Col lg={6} className="pl7">
                          
                          <div className="basicinput modalinputgap">
                            <p>Salary Range</p>
                            <div className="inputgap">
  
                            <div className="dropdownwrapper">
                              
                                <input type="text" style={bordersalaryRangeMod2 ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }} value={salaryRangeMod2} onChange={(e)=>setsalaryRangeMod2(e.target.value)}/>
                            </div>
                            <label>{labelsalaryRangeMod2}</label>
                            </div>
                            </div>
                          </Col>
                          <Col lg={6} className="pr7">
                          <div className="basicinput modalinputgap">                          
                                <p>Employee Type</p>
                                <div className="inputgap h40">
                                <div className="dropdownwrapper">
                                    
                                    <Dropdown2 err={borderemployeeTypeMod2} func={drpfuncEmpTypeMod2} myplaceholder="Select" fontsize="16" fontfamily="'Poppins', sans-serif"  options={optionsStatus}/>
                                </div>                                
                                <label>{labellevelMod2}</label>
                                </div>
                                </div>
                          </Col>
                          <Col lg={6} className="pl7">
                          <div className="basicinput modalinputgap">                          
                                <p>Work Place</p>
                                <div className="inputgap h40">
                                <div className="dropdownwrapper">
                                    
                                    <Dropdown2 err={borderworkPlaceMod2} func={drpfuncWorkPlaceMod2} myplaceholder="Select" fontsize="16" fontfamily="'Poppins', sans-serif"  options={optionsStatus}/>
                                </div>                                
                                <label>{labelworkPlaceMod2}</label>
                                </div>
                                </div>
                          </Col>
                          <Col lg={6} className="pr7">
                          
                          <div className="basicinput modalinputgap">
                            <p>Experience Required</p>
                            <div className="inputgap">
  
                            <div className="dropdownwrapper">
                              
                                <input type="text" style={borderexpRequiredMod2 ? { borderColor: "rgb(237, 28, 36)" } : { borderColor: "rgba(0,0,0,0.2)" }} value={expRequiredMod2} onChange={(e)=>setexpRequiredMod2(e.target.value)}/>
                            </div>
                            <label>{labelexpRequiredMod2}</label>
                            </div>
                            </div>
                          </Col>
                          <Col lg={12}>
                               
                          <div className="basicinput modalinputgap w-100">

                           <p>Description</p>
                               <div className="inputgap" style={{height:"100px",width:"100%"}}>
                               <textarea  style={borderdescriptionMod2 ? { borderColor: "rgb(237, 28, 36)",width:"100%",height:"100px" } : { borderColor: "rgba(0,0,0,0.2)",width:"100%",height:"100px" }} className="textbox" type="text" name="description" value={descriptionMod2} onChange={(e)=>setdescriptionMod2(e.target.value)} placeholder=''/>
                               <label>{labeldescriptionMod2}</label>
                               </div> 
                          </div>  
                        </Col>
                      </Row>
                    </Col>
                  </Row>

                </Modal.Body>
                <Modal.Footer className="m-auto" style={{borderTop:"0"}}>
                  <button variant="secondary" type="button" onClick={handleClose}>
                    Close
                  </button>
                  <button variant="primary" onClick={handlesaveModal2}>
                    Update
                  </button>
                </Modal.Footer>

                
              </Modal>
            </div>
        </div>
    </div>
    </>
  )
}

export default HRJobManagementComp